import comp from '../components/barrel';
import U from '../js/utils';
import config from '../js/config';

let appListfilters = {};
let appListTimeout = null;
let targetAdvisorTimeout = null;

export default {
  async prepare() {
    const vars = {};
    vars.filters = {};
    this.vars.selected_page = 1;
    this.vars.selectedAppUuids = this.vars.selectedAppUuids || {};
    this.vars.target_advisor = '';
    this.vars.target_advisor_text = '';
    // Lookup data only — do not call application/app-list until advisor/org/org-branch is set
    this.recipe.methods.push(await O.mPOST('communal/divisions', vars));
    this.recipe.methods.push(await O.mPOST('communal/div-branches', vars));
    this.recipe.methods.push(await O.mPOST('communal/organisations', vars));
    this.recipe.methods.push(await O.mPOST('communal/org-branches', vars));
    this.recipe.methods.push(await O.mPOST('communal/app_status', vars));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    document.addEventListener('change', (e) => {
      if (
        e.target.id === 'statusDD' ||
        e.target.id === 'companyDD' ||
        e.target.id === 'companyBranchDD'
      ) {
        this.debouncedGetAppList();
      }
    });

    document.addEventListener('mousedown', (e) => {
      let suggestionItemParent = e.target.parentNode;
      let orgListDropdownEl = U.id('orgListDropdownContainer');
      if (orgListDropdownEl && e.target !== orgListDropdownEl && suggestionItemParent.id !== 'orgListDropdown') {
        orgListDropdownEl.remove();
      }

      let orgBranchListDropdownEl = U.id('orgBranchListDropdownContainer');
      if (
        orgBranchListDropdownEl &&
        e.target !== orgBranchListDropdownEl &&
        suggestionItemParent.id !== 'orgBranchListDropdown'
      ) {
        orgBranchListDropdownEl.remove();
      }

      let advisorDropdownEl = U.id('advisorListDropdownContainer');
      if (
        advisorDropdownEl &&
        e.target !== advisorDropdownEl &&
        suggestionItemParent.id !== 'advisorListDropdown'
      ) {
        advisorDropdownEl.remove();
      }

      let targetAdvisorDropdownEl = U.id('targetAdvisorListDropdownContainer');
      if (
        targetAdvisorDropdownEl &&
        e.target !== targetAdvisorDropdownEl &&
        suggestionItemParent.id !== 'targetAdvisorListDropdown'
      ) {
        targetAdvisorDropdownEl.remove();
      }
    });

    await this.buildTableHead(data);
    await this.buildTableBody([]);
    this.hideTargetAdvisorBar();
    this.setupSearchInputEvents();
  },

  hasRequiredFilter() {
    return !!(thsPage.vars.advisor || thsPage.vars.organisation || thsPage.vars.organisation_branch);
  },

  debouncedGetAppList() {
    clearTimeout(appListTimeout);
    appListTimeout = setTimeout(() => {
      this.getAppList();
    }, 500);
  },

  async fetchAndRenderAppList(vars) {
    const res = await O.PREP([await O.mPOST('application/app-list', vars)]);
    const listData = res['application/app-list'];
    const appListData = listData.data;
    const paginationState = listData.pagination;
    const hasRows = Array.isArray(appListData) && appListData.length > 0;

    await this.buildTableBody(appListData);

    // Target advisor UI only after application/app-list returns rows
    if (hasRows) {
      await this.setupTargetAdvisorBar();
      this.showTargetAdvisorBar();
    } else {
      this.hideTargetAdvisorBar();
    }

    this.buildPaginationButtons(paginationState);
    this.updatePaginationInfo(paginationState);
    thsPage.vars.selected_page = paginationState.current_page;
  },

  async buildTableHead(data) {
    const companyDDdata = data['communal/divisions']?.data?.divisions || [];
    const companyBranchDDdata = await data[`communal/div-branches`].data;
    const statusDDdata = await data[`communal/app_status`].data;

    const appTableHead = U.id('appTableHead');
    appTableHead.innerHTML = '';
    const headRow = appTableHead.insertRow();

    const selectAllHead = headRow.insertCell(0);
    selectAllHead.style.textAlign = 'center';
    const selectAllCheckbox = document.createElement('input');
    selectAllCheckbox.type = 'checkbox';
    selectAllCheckbox.id = 'selectAllApps';
    selectAllCheckbox.className = 'cursor-pointer';
    selectAllCheckbox.style.transform = 'scale(1.4)';
    selectAllCheckbox.title = 'Select all';
    selectAllCheckbox.addEventListener('change', (e) => {
      thsPage.toggleSelectAll(e.target.checked);
    });
    selectAllHead.appendChild(selectAllCheckbox);

    const flaggedHead = headRow.insertCell(1);
    flaggedHead.innerHTML = '&nbsp;';
    flaggedHead.style.textAlign = 'center';

    const party1 = headRow.insertCell(2);
    party1.innerHTML = 'Party 1';

    const party2 = headRow.insertCell(3);
    party2.innerHTML = 'Party 2';

    const status = headRow.insertCell(4);
    let statusDD = await comp.selectThead('statusDD', statusDDdata, 'application_status_uuid', 'short_text', '', 'Status');
    status.appendChild(statusDD);

    const willNumberHead = headRow.insertCell(5);
    willNumberHead.innerHTML = 'Will number';

    const icons = headRow.insertCell(6);
    icons.innerHTML = '&nbsp;';

    const advisor = headRow.insertCell(7);
    let advisorDD = await comp.inputText('advisorDD', '', '', 0, '', 'Advisors', true);
    advisor.appendChild(advisorDD);

    const sourceRef = headRow.insertCell(8);
    sourceRef.innerHTML = 'Date Created';

    const appType = headRow.insertCell(9);
    appType.innerHTML = 'App Type';

    const organisation = headRow.insertCell(10);
    let organisationDD = await comp.inputText('organisationDD', '', '', 0, '', 'Org.', true);
    organisation.appendChild(organisationDD);

    const organisationBranch = headRow.insertCell(11);
    let organisationBranchDD = await comp.inputText('organisationBranchDD', '', '', 0, '', 'Org. branch', true);
    organisationBranch.appendChild(organisationBranchDD);

    const company = headRow.insertCell(12);
    if (companyDDdata.length) {
      let companyDD = await comp.selectThead('companyDD', companyDDdata, 'division_uuid', 'short_text', '', 'Company');
      company.appendChild(companyDD);
    } else {
      company.innerHTML = '<span>No companies available</span>';
    }

    const companyBranch = headRow.insertCell(13);
    let companyBranchDD = await comp.selectThead(
      'companyBranchDD',
      companyBranchDDdata,
      'division_branch_uuid',
      'short_text',
      '',
      'Company Branch'
    );
    companyBranch.appendChild(companyBranchDD);
  },

  async buildTableBody(appListData) {
    let appTableBody = U.id('appTableBody');
    appTableBody.innerHTML = '';

    if (!appListData || !appListData.length) {
      const appRow = appTableBody.insertRow();
      const emptyCell = appRow.insertCell(0);
      emptyCell.innerHTML = this.hasRequiredFilter()
        ? 'No applications available.'
        : 'Select an advisor, organisation or org branch to load applications.';
      emptyCell.colSpan = 14;
      this.syncSelectAllCheckbox();
      this.hideTargetAdvisorBar();
      return;
    }

    const selected = thsPage.vars.selectedAppUuids || {};

    for (const row of appListData) {
      const appRow = appTableBody.insertRow();

      const selectCell = appRow.insertCell(0);
      selectCell.style.textAlign = 'center';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'cursor-pointer';
      checkbox.style.transform = 'scale(1.4)';
      checkbox.dataset.applicationUuid = row.application_uuid;
      checkbox.checked = !!selected[row.application_uuid];
      checkbox.addEventListener('change', (e) => {
        if (!thsPage.vars.selectedAppUuids) thsPage.vars.selectedAppUuids = {};
        if (e.target.checked) {
          thsPage.vars.selectedAppUuids[row.application_uuid] = true;
        } else {
          delete thsPage.vars.selectedAppUuids[row.application_uuid];
        }
        thsPage.syncSelectAllCheckbox();
      });
      selectCell.appendChild(checkbox);

      const flaggedCell = appRow.insertCell(1);
      flaggedCell.style.textAlign = 'center';

      const party1_names = appRow.insertCell(2);
      party1_names.innerHTML = row.party1_names;

      const party2_names = appRow.insertCell(3);
      party2_names.innerHTML = row.party2_names;

      const status = appRow.insertCell(4);
      const tag = await comp.statusTag(row.status);
      status.appendChild(tag);

      const willNumberCell = appRow.insertCell(5);
      const willNum = row.importwillnumber;
      willNumberCell.innerHTML =
        willNum !== undefined && willNum !== null && willNum !== '' ? String(willNum) : '';

      const icons = appRow.insertCell(6);
      icons.style.textAlign = 'center';

      const iconsContainer = document.createElement('div');
      iconsContainer.style.display = 'flex';
      iconsContainer.style.gap = '4px';
      iconsContainer.style.justifyContent = 'center';
      iconsContainer.style.alignItems = 'center';

      if (row.final_discount_yn === true || row.final_discount_yn === 'true' || row.final_discount_yn === 1) {
        const dCircle = document.createElement('div');
        dCircle.style.width = '20px';
        dCircle.style.height = '20px';
        dCircle.style.borderRadius = '50%';
        dCircle.style.backgroundColor = '#3b82f6';
        dCircle.style.color = 'white';
        dCircle.style.display = 'flex';
        dCircle.style.alignItems = 'center';
        dCircle.style.justifyContent = 'center';
        dCircle.style.fontSize = '12px';
        dCircle.style.fontWeight = 'bold';
        dCircle.style.cursor = 'help';
        dCircle.textContent = 'D';
        dCircle.title = 'Discount recorded';
        iconsContainer.appendChild(dCircle);
      }

      if (row.has_products_yn === true || row.has_products_yn === 'true' || row.has_products_yn === 1) {
        const pCircle = document.createElement('div');
        pCircle.style.width = '20px';
        pCircle.style.height = '20px';
        pCircle.style.borderRadius = '50%';
        pCircle.style.backgroundColor = '#3b82f6';
        pCircle.style.color = 'white';
        pCircle.style.display = 'flex';
        pCircle.style.alignItems = 'center';
        pCircle.style.justifyContent = 'center';
        pCircle.style.fontSize = '12px';
        pCircle.style.fontWeight = 'bold';
        pCircle.style.cursor = 'help';
        pCircle.textContent = 'P';
        pCircle.title = 'Products linked';
        iconsContainer.appendChild(pCircle);
      }

      icons.appendChild(iconsContainer);

      const advisor = appRow.insertCell(7);
      advisor.innerHTML = row.advisor;

      const created_date = appRow.insertCell(8);
      created_date.innerHTML = await U.formatDate(row.created_date);

      const will_type = appRow.insertCell(9);
      will_type.innerHTML = row.app_type;

      const organisation = appRow.insertCell(10);
      organisation.innerHTML = row.organisation;

      const organisationBranch = appRow.insertCell(11);
      organisationBranch.innerHTML = row.organisation_branch;

      const company = appRow.insertCell(12);
      company.innerHTML = row.company;

      const companyBranch = appRow.insertCell(13);
      companyBranch.innerHTML = row.company_branch;
    }

    this.syncSelectAllCheckbox();
  },

  async setupTargetAdvisorBar() {
    const container = U.id('targetAdvisorLookupContainer');
    if (!container || container.querySelector('#targetAdvisorDD')) return;

    const targetAdvisorInput = await comp.inputText('targetAdvisorDD', '', '', 0, '', 'Search advisor...', true);
    container.appendChild(targetAdvisorInput);

    const input = U.id('targetAdvisorDD');
    if (input) {
      input.addEventListener('input', () => {
        if (input.value === '') {
          thsPage.vars.target_advisor = '';
          thsPage.vars.target_advisor_text = '';
          thsPage.updateChangeAdvisorButtonVisibility();
        }
        clearTimeout(targetAdvisorTimeout);
        const query = input.value.trim();
        if (query.length < 3) {
          const dropdown = U.id('targetAdvisorListDropdownContainer');
          if (dropdown) dropdown.remove();
          return;
        }
        targetAdvisorTimeout = setTimeout(() => {
          thsPage.getSuggestedTargetAdvisors();
        }, 1000);
      });
    }
  },

  showTargetAdvisorBar() {
    const bar = U.id('targetAdvisorBar');
    if (!bar) return;
    bar.hidden = false;
    bar.classList.add('flex');
    this.setupChangeAdvisorFileInput();
    this.updateChangeAdvisorButtonVisibility();
  },

  hideTargetAdvisorBar() {
    const bar = U.id('targetAdvisorBar');
    if (!bar) return;
    bar.hidden = true;
    bar.classList.remove('flex');

    thsPage.vars.target_advisor = '';
    thsPage.vars.target_advisor_text = '';

    const input = U.id('targetAdvisorDD');
    if (input) input.value = '';

    const dropdown = U.id('targetAdvisorListDropdownContainer');
    if (dropdown) dropdown.remove();

    const lookup = U.id('targetAdvisorLookupContainer');
    if (lookup) lookup.innerHTML = '';

    this.clearChangeAdvisorFile();
    this.updateChangeAdvisorButtonVisibility();
  },

  setupChangeAdvisorFileInput() {
    const fileInput = U.id('changeAdvisorFile');
    if (!fileInput || fileInput.dataset.bound === '1') return;
    fileInput.dataset.bound = '1';
    fileInput.addEventListener('change', () => {
      fileInput.classList.remove('input-error');
      thsPage.updateChangeAdvisorButtonVisibility();
    });
  },

  clearChangeAdvisorFile() {
    const fileInput = U.id('changeAdvisorFile');
    if (fileInput) {
      fileInput.value = '';
      fileInput.classList.remove('input-error');
    }
    const fileContainer = U.id('changeAdvisorFileContainer');
    if (fileContainer) {
      fileContainer.hidden = true;
      fileContainer.classList.remove('flex');
    }
  },

  updateChangeAdvisorButtonVisibility() {
    const btn = U.id('changeAdvisorBtn');
    const fileContainer = U.id('changeAdvisorFileContainer');
    if (!btn) return;

    const hasTarget = !!thsPage.vars.target_advisor;
    const selected = thsPage.vars.selectedAppUuids || {};
    const hasSelectedRows = Object.keys(selected).length > 0;
    const fileInput = U.id('changeAdvisorFile');
    const hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

    // File selector only when Change advisor button is shown
    if (fileContainer) {
      fileContainer.hidden = !hasTarget;
      fileContainer.classList.toggle('flex', hasTarget);
    }
    btn.hidden = !hasTarget;
    btn.disabled = !hasTarget || !hasSelectedRows || !hasFile;
  },

  clearTargetAdvisorSelection() {
    thsPage.vars.target_advisor = '';
    thsPage.vars.target_advisor_text = '';

    const input = U.id('targetAdvisorDD');
    if (input) input.value = '';

    const dropdown = U.id('targetAdvisorListDropdownContainer');
    if (dropdown) dropdown.remove();

    this.clearChangeAdvisorFile();
    this.updateChangeAdvisorButtonVisibility();
  },

  async getSuggestedTargetAdvisors() {
    const targetAdvisorInput = U.id('targetAdvisorDD');
    if (!targetAdvisorInput) return;

    const existingContainer = U.id('targetAdvisorListDropdownContainer');
    if (existingContainer) {
      existingContainer.remove();
    }

    const query = targetAdvisorInput.value.trim();
    if (query.length < 3) {
      if (targetAdvisorInput.value === '') {
        thsPage.vars.target_advisor = '';
        thsPage.vars.target_advisor_text = '';
        this.updateChangeAdvisorButtonVisibility();
      }
      return;
    }

    const vars = {};
    vars.search_filter = query;

    try {
      const res = await O.PREP([await O.mPOST('communal/advisor-autosuggest', vars)]);
      const advisorListData = res['communal/advisor-autosuggest'].data;
      const advisorListDropdown = await comp.dataListDropdown({
        elID: 'targetAdvisorListDropdown',
        ddData: advisorListData,
        valueDataName: 'user_uuid',
        textDataName: 'combo_text',
        requiredYN: 0,
        onselect: 'handleTargetAdvisorSelection',
        className: 'targetAdvisorSuggestionOption',
      });
      const inputDiv = U.id('targetAdvisorDDDiv');
      if (inputDiv) inputDiv.appendChild(advisorListDropdown);
    } catch (e) {}
  },

  handleTargetAdvisorSelection() {
    const dropdown = U.id('targetAdvisorListDropdownContainer');
    if (dropdown) {
      dropdown.remove();
    }

    if (thsPage.vars.target_advisor_text) {
      U.id('targetAdvisorDD').value = thsPage.vars.target_advisor_text;
    }

    this.updateChangeAdvisorButtonVisibility();
  },

  async changeAdvisor() {
    const targetAdvisorUuid = thsPage.vars.target_advisor;
    const selected = thsPage.vars.selectedAppUuids || {};
    const applicationUuids = Object.keys(selected);
    const fileInput = U.id('changeAdvisorFile');
    const file = fileInput && fileInput.files && fileInput.files[0];

    if (!targetAdvisorUuid || !applicationUuids.length) return;

    if (!file) {
      if (fileInput) fileInput.classList.add('input-error');
      comp.errorBox('Missing file', 'Please choose a file before changing advisor.');
      return;
    }

    const formData = new FormData();
    formData.append('target_advisor_uuid', targetAdvisorUuid);
    applicationUuids.forEach((uuid) => formData.append('application_uuid', uuid));
    formData.append('uploadFile', file);

    const btn = U.id('changeAdvisorBtn');
    if (btn) btn.disabled = true;

    try {
      const hdrs = await O.getAuthHdrs();
      const response = await fetch(`${config.apiURL}application/change-advisor`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
        },
        body: formData,
      });

      let outcome;
      try {
        outcome = await response.json();
      } catch (e) {
        outcome = null;
      }

      if (!response.ok) {
        const errorMsg =
          (outcome && outcome.data && outcome.data.error) ||
          (outcome && outcome.error) ||
          'Failed to change advisor.';
        comp.errorBox('Error', errorMsg);
        return;
      }

      if (outcome && outcome.status === 'OK') {
        comp.toast(outcome.status);
        thsPage.vars.selectedAppUuids = {};
        this.clearTargetAdvisorSelection();
        await this.getAppList(false, true);
      } else {
        comp.errorBox(
          'Error',
          (outcome && outcome.data && outcome.data.error) || 'Failed to change advisor.'
        );
      }
    } catch (error) {
      comp.errorBox('Error', 'Failed to change advisor. Please try again.');
    } finally {
      this.updateChangeAdvisorButtonVisibility();
    }
  },

  toggleSelectAll(checked) {
    if (!thsPage.vars.selectedAppUuids) thsPage.vars.selectedAppUuids = {};
    const checkboxes = U.id('appTableBody').querySelectorAll('input[type="checkbox"][data-application-uuid]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
      const uuid = checkbox.dataset.applicationUuid;
      if (checked) {
        thsPage.vars.selectedAppUuids[uuid] = true;
      } else {
        delete thsPage.vars.selectedAppUuids[uuid];
      }
    });
    this.updateChangeAdvisorButtonVisibility();
  },

  syncSelectAllCheckbox() {
    const selectAll = U.id('selectAllApps');
    if (!selectAll) return;
    const checkboxes = U.id('appTableBody').querySelectorAll('input[type="checkbox"][data-application-uuid]');
    if (!checkboxes.length) {
      selectAll.checked = false;
      selectAll.indeterminate = false;
      this.updateChangeAdvisorButtonVisibility();
      return;
    }
    const checkedCount = [...checkboxes].filter((cb) => cb.checked).length;
    selectAll.checked = checkedCount === checkboxes.length;
    selectAll.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length;
    this.updateChangeAdvisorButtonVisibility();
  },

  async buildPaginationButtons(paginationState) {
    await comp.paginationButtons({totalPages: paginationState.total_pages, wrapperID: 'appPaginationWrapper'});
    const pageButtons = document.querySelectorAll('.pageButton');
    pageButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        thsPage.vars.selected_page = Number(e.target.getAttribute('value'));
        this.getAppList(false, true);
      });
    });

    this.updatePaginationInfo(paginationState);
  },

  updatePaginationInfo(paginationState) {
    const totalRecordsBottom = U.id('totalRecordsDisplayBottom');
    const totalPagesBottom = U.id('totalPagesDisplayBottom');
    if (totalRecordsBottom) {
      totalRecordsBottom.textContent = paginationState.total_records || '-';
    }
    if (totalPagesBottom) {
      totalPagesBottom.textContent = paginationState.total_pages || '-';
    }
  },

  clearPaginationInfo() {
    this.updatePaginationInfo({total_records: '-', total_pages: '-'});
    const wrapper = U.id('appPaginationWrapper');
    if (wrapper) wrapper.innerHTML = '';
  },

  collectFilters() {
    const companyDDEl = U.id('companyDD');
    appListfilters.company = companyDDEl ? companyDDEl.value : '';
    const companyBranchDDEl = U.id('companyBranchDD');
    appListfilters.company_branch = companyBranchDDEl ? companyBranchDDEl.value : '';

    appListfilters.organisation = thsPage.vars.organisation || '';
    appListfilters.organisation_branch = thsPage.vars.organisation_branch || '';

    const statusDDEl = U.id('statusDD');
    appListfilters.status = statusDDEl ? statusDDEl.value : '';

    appListfilters.advisor = thsPage.vars.advisor || '';
    appListfilters.openApplicationsYN = false;
  },

  async getAppList(filtersCleared, fromPagination) {
    if (!fromPagination) {
      thsPage.vars.selected_page = 1;
    }

    this.collectFilters();

    if (!this.hasRequiredFilter()) {
      await this.buildTableBody([]);
      this.clearPaginationInfo();
      return;
    }

    setTimeout(async () => {
      const vars = {};
      vars.filters = appListfilters;
      vars.limit = 50;
      vars.page = parseInt(thsPage.vars.selected_page) || 1;

      try {
        await this.fetchAndRenderAppList(vars);
      } catch (error) {
      }
    }, 500);
  },

  async getSuggestedOrganisations() {
    let orgInputTextEl = U.id('organisationDD');

    if (orgInputTextEl.value === '') {
      thsPage.vars.organisation = '';
      thsPage.vars.organisation_text = '';
      this.getAppList();
    }

    let orgListDropdownEl = U.id('orgListDropdown');
    if (orgListDropdownEl) {
      orgListDropdownEl.remove();
    }

    let orgBranchListDropdownEl = U.id('orgBranchListDropdown');
    if (orgBranchListDropdownEl) {
      orgBranchListDropdownEl.remove();
    }

    clearTimeout(window.timeout);
    window.timeout = setTimeout(async () => {
      const filters = {};
      filters.search_filters = U.id('organisationDD').value.trim();

      const vars = {};
      vars.filters = filters;

      O.PREP([await O.mPOST('communal/organisations', vars)])
        .then(async (res) => {
          const orgListData = res['communal/organisations'].data;
          const orgListDropdown = await comp.dataListDropdown({
            elID: 'orgListDropdown',
            ddData: orgListData,
            valueDataName: 'org_uuid',
            textDataName: 'long_text',
            requiredYN: 0,
            onselect: 'handleOrganisationSelection',
            className: 'orgSuggestionOption',
          });
          U.id('organisationDDDiv').appendChild(orgListDropdown);
        })
        .catch(() => {});
    }, 300);
  },

  async getSuggestedOrganisationBranches() {
    let orgBranchInputTextEl = U.id('organisationBranchDD');

    if (orgBranchInputTextEl.value === '') {
      thsPage.vars.organisation_branch = '';
      thsPage.vars.organisation_branch_text = '';
      this.getAppList();
    }

    let orgListDropdownEl = U.id('orgListDropdown');
    if (orgListDropdownEl) {
      orgListDropdownEl.remove();
    }

    let orgBranchListDropdownEl = U.id('orgBranchListDropdown');
    if (orgBranchListDropdownEl) {
      orgBranchListDropdownEl.remove();
    }

    clearTimeout(window.timeout);
    window.timeout = setTimeout(async () => {
      const filters = {};
      filters.search_filters = U.id('organisationBranchDD').value.trim();

      const vars = {};
      vars.filters = filters;

      O.PREP([await O.mPOST('communal/org-branches', vars)])
        .then(async (res) => {
          const orgBranchListData = res['communal/org-branches'].data;
          const orgBranchListDropdown = await comp.dataListDropdown({
            elID: 'orgBranchListDropdown',
            ddData: orgBranchListData,
            valueDataName: 'org_branch_uuid',
            textDataName: 'combo_text',
            requiredYN: 0,
            onselect: 'handleOrganisationBranchSelection',
            className: 'orgBranchSuggestionOption',
          });
          U.id('organisationBranchDDDiv').appendChild(orgBranchListDropdown);
        })
        .catch(() => {});
    }, 300);
  },

  async getSuggestedAdvisors() {
    let advisorInputTextEl = U.id('advisorDD');
    this.clearTargetAdvisorSelection();

    if (advisorInputTextEl.value === '') {
      thsPage.vars.advisor = '';
      thsPage.vars.advisor_text = '';
      this.getAppList();
    }

    let advisorListDropdownEl = U.id('advisorListDropdown');
    if (advisorListDropdownEl) {
      advisorListDropdownEl.remove();
    }
    const advisorListDropdownContainer = U.id('advisorListDropdownContainer');
    if (advisorListDropdownContainer) {
      advisorListDropdownContainer.remove();
    }

    const query = advisorInputTextEl.value.trim();
    if (query.length < 3) return;

    const vars = {};
    vars.search_filter = query;

    try {
      const res = await O.PREP([await O.mPOST('communal/advisor-autosuggest', vars)]);
      const advisorListData = res['communal/advisor-autosuggest'].data;
      const advisorListDropdown = await comp.dataListDropdown({
        elID: 'advisorListDropdown',
        ddData: advisorListData,
        valueDataName: 'user_uuid',
        textDataName: `combo_text`,
        requiredYN: 0,
        onselect: 'handleAdvisorSelection',
        className: 'advisorSuggestionOption',
      });
      U.id('advisorDDDiv').appendChild(advisorListDropdown);
    } catch (e) {}
  },

  setupSearchInputEvents() {
    setTimeout(() => {
      const organisationDD = U.id('organisationDD');
      if (organisationDD) {
        organisationDD.addEventListener('input', () => {
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.getSuggestedOrganisations();
          }, 300);
        });
      }

      const organisationBranchDD = U.id('organisationBranchDD');
      if (organisationBranchDD) {
        organisationBranchDD.addEventListener('input', () => {
          clearTimeout(window.timeout);
          window.timeout = setTimeout(() => {
            this.getSuggestedOrganisationBranches();
          }, 300);
        });
      }

      const advisorDD = U.id('advisorDD');
      if (advisorDD) {
        advisorDD.addEventListener('input', () => {
          clearTimeout(window.timeout);
          const query = advisorDD.value.trim();
          if (query.length < 3) {
            const dropdown = U.id('advisorListDropdownContainer');
            if (dropdown) dropdown.remove();
            if (advisorDD.value === '') {
              thsPage.vars.advisor = '';
              thsPage.vars.advisor_text = '';
              this.getAppList();
            }
            return;
          }
          window.timeout = setTimeout(() => {
            this.getSuggestedAdvisors();
          }, 1000);
        });
      }
    }, 100);
  },

  handleOrganisationSelection() {
    const orgListDropdownEl = U.id('orgListDropdownContainer');
    if (orgListDropdownEl) {
      orgListDropdownEl.remove();
    }

    if (thsPage.vars.organisation_text) {
      U.id('organisationDD').value = thsPage.vars.organisation_text;
    }

    this.debouncedGetAppList();
  },

  handleOrganisationBranchSelection() {
    const orgBranchListDropdownEl = U.id('orgBranchListDropdownContainer');
    if (orgBranchListDropdownEl) {
      orgBranchListDropdownEl.remove();
    }

    if (thsPage.vars.organisation_branch_text) {
      U.id('organisationBranchDD').value = thsPage.vars.organisation_branch_text;
    }

    this.debouncedGetAppList();
  },

  handleAdvisorSelection() {
    const advisorListDropdownEl = U.id('advisorListDropdownContainer');
    if (advisorListDropdownEl) {
      advisorListDropdownEl.remove();
    }

    if (thsPage.vars.advisor_text) {
      U.id('advisorDD').value = thsPage.vars.advisor_text;
    }

    this.clearTargetAdvisorSelection();
    this.debouncedGetAppList();
  },
};
